import { ShopStore } from 'stores';
import { customFleets } from 'shared';

/**
 * Safely checks if the current shop is part of the UFP fleet.
 * This function ensures that shop data is properly loaded before checking
 * the customFleet array membership.
 *
 * @returns {boolean} True if the shop is part of UFP fleet, false otherwise
 */
export const isUfpFleet = () => {
  try {
    if (!ShopStore.currentShop || !ShopStore.currentShop.id) {
      console.debug('UFP Fleet Check: No shop data available');
      return false;
    }

    const shopId = ShopStore.currentShop.id;
    const parentShopId = ShopStore.currentShop.parentShopId;

    let idToCheck =
      parentShopId && parentShopId !== null ? parentShopId : shopId;

    if (!Array.isArray(customFleets.ufpFleet)) {
      console.warn('UFP Fleet Check: customFleets.ufpFleet is not an array');
      return false;
    }

    // check if is a string. Try to convert to number. If it fails, return false
    if (typeof idToCheck === 'string') {
      const numId = Number(idToCheck);
      if (isNaN(numId)) {
        console.warn('UFP Fleet Check: idToCheck is not a number', idToCheck);
        return false;
      }
      idToCheck = numId;
    }

    const isUfp = customFleets.ufpFleet.includes(idToCheck);
    console.debug(
      `UFP Fleet Check: shopId=${shopId}, parentShopId=${parentShopId}, checking=${idToCheck}, isUfp=${isUfp}`
    );

    return isUfp;
  } catch (error) {
    console.warn('Error checking UFP fleet membership:', error);
    return false;
  }
};
